import React, { useEffect } from 'react'
// import { Location } from '@reach/router'
import queryString from 'query-string'
import { useHideInput } from '../../contextHook/hideInput'
import { useAsyncDispatch } from '../../hook/useAsync'
import { getShareLink } from '../../redux/shareWheel/actions'
import { useFullScreenHandle } from 'react-full-screen'
import { getPersistor } from '../../utils/reduxPersistor'
import { useToast } from '../../contextHook/toast'
import { useFontLoaded } from '../../hook/useFontLoaded'
// import HideInputProvider from '../../contextHook/hideInput'

const withWheelToolHOC = (ComponentToWrap, page) => props => {
  const handleHideInput = useHideInput()
  const handleFullScreen = useFullScreenHandle()
  const { execute: getShareLinkAsync, loading: getShareLoading } =
    useAsyncDispatch(getShareLink)
  const toast = useToast()
  useFontLoaded(page)

  const pageHasQuiz = page === 'rcg'

  useEffect(() => {
    const search = props.location.search
      ? queryString.parse(props.location.search)
      : {}
    const shareId = search.id
    if (shareId) {
      getPersistor().pause()

      const data = {
        sharePage: page,
        sharePath: shareId,
      }

      if (pageHasQuiz) {
        data.quizMode = props.pageContext?.route === 'quiz'
      }

      getShareLinkAsync(data).catch(error => {
        getPersistor().persist()
        console.log(error)
        toast.warning(error.error)
        // if (shareId.length === 8) {
        //   setTimeout(() => {
        //     // window.open(window.location.pathname,'_self')
        //     // window.open(props.location.pathname, '_self')
        //     window.location.href = window.location.pathname
        //   }, 2500)
        // }
      })
    }
  }, [])

  return (
    <ComponentToWrap
      {...props}
      search={
        props.location.search ? queryString.parse(props.location.search) : {}
      }
      handleHideInput={handleHideInput}
      handleFullScreen={handleFullScreen}
      getShareLoading={getShareLoading}
    />
  )
}

export default withWheelToolHOC
